
import { getLocalStorage } from "utils";
import store from "../redux-store/index";
import { exec, isElectron } from "./nativeHooks";
import { CLOSED, LOCALSTORAGE_KEYS } from "./constants";
import { USBPrinter, getAddedBlePrintersList } from "./localStorage";
import { NW_APP_EVENT_ACTIONS, NW_APP_EVENT_KEYS, PRINTER_TYPES_KEYS } from "data/constants";
import { printSale } from "helper/printHelper";
import { getUnprintedTicketsFn, isOffline } from "facade/ServiceFacade";
import { updateAllTicketsPrintStatus } from "helper/OfflineHelper";
import { printKOTSlice, printLabelSlice } from "redux-store/slices/TableViewSlice";
import { getAllAddedLabelPrintersList } from "helper/printHelper";
import { isEmpty } from "lodash";
import { ToastNotifyError } from "commonComponents/ToastNotify";
import { getErrorMessage } from "./pos_errors";
import moment from "moment";
let taskQ = [];
let isPollingInProgress = false;
let cancelDebounce = false;

function arrayToMap(array, id) {
  if (!array || !array.length || array.length === 0) {
    return null
  }
  return array.reduce((map, obj) => {
    map[obj[id]] = obj
    return map
  }, {})
}

function debounce(func) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, args[0]);
  };
}

function getPollingConfig() {
  const state = store.getState();
  const posSettings = state?.catalogStore?.posSettings || {};
  const deviceIdentifier = getLocalStorage(LOCALSTORAGE_KEYS.deviceIdentifier);

  const tickets = posSettings?.tickets || {};
  const labels = posSettings?.itemLabelSettings || {};

  const isTicketPrinter = tickets?.printDeviceId === deviceIdentifier;
  const isLabelPrinter = labels?.printDeviceId === deviceIdentifier;

  const hasTicketGroups = Array.isArray(tickets?.groups) && tickets.groups.length > 0;

  return {
    deviceIdentifier,
    tickets,
    labels,
    isTicketPrinter,
    isLabelPrinter,
    hasTicketGroups,
    canPollTicket: isTicketPrinter && hasTicketGroups,
    canPollLabel: isLabelPrinter,
  };
}


let resetDelayedTask = debounce(() => {
  const { isTicketPrinter, isLabelPrinter } = getPollingConfig();

  if (!cancelDebounce && (isTicketPrinter || isLabelPrinter)) {
    createDelayedTasks();
  } else {
    return
  }
});

//! POLLING START
//! STEP 1
//! if poll in progress loop for every sec to check when polling is done/not in progress to start delayed task in 200ms
export function pollForTickets() {
  // debugger
    // console.time('Polling_start_1')
  cancelDebounce = false;
  //   debugger;
  // let me = this,
  // let tickets = (AppContext.businessData.posSettings || {}).tickets;

  const { canPollTicket, canPollLabel } = getPollingConfig();

  if (!canPollTicket && !canPollLabel) return;
  //Try after 1 second if polling in progress.
  //   if (false) {
  if (isPollingInProgress) {
    // Req -> getPollingInProgress
    setTimeout(function () {
      pollForTickets();
    }, 1000);
  } else {
    // resetDelayedTask(delayedSaleTicketTask, 200); // resetDelayedTask -> write your own
    resetDelayedTask(200);
  }
}

//! STEP 2 : Polling delayed task
//! Fetch sale tickets

// function delayedSaleTicketTask() {
//   let callbacks = {
//     successCallback: onSaleTicketSuccess,
//     appErrorCallback: onSaleTicketError,
//     failureCallback: onSaleTicketFailure,
//   };
//   setPollingInProgress(true);
//   Rista.CommonService.getSaleTicketsToPrint({ pageSize: 10 }, callbacks); // fetch API call here //
//   // taskQ = APIResponse
// }

function createDelayedTasks() {
  isPollingInProgress = true;
  //  // setPollingInProgress(true);
  // function delayedSaleTicketTask(token) {
  //   // the token is for cancellation
  //   // let url = `http://localhost:3000/business/services/bn/sale/ticket/unprinted`;
  //   let url = `${RISTA_API_URL}${RISTA_COMMON_URL}/sale/ticket/unprinted`;
  //   let xhr = new XMLHttpRequest();
  //   xhr.open("POST", url);
  //   xhr.setRequestHeader("Content-type", "application/json");
  //   xhr.setRequestHeader(
  //     "deviceIdentifier",
  //     getLocalStorage("deviceIdentifier")
  //   );
  //   xhr.setRequestHeader("ATOKEN", getLocalStorage("ATOKEN"));
  //   xhr.send(JSON.stringify({ pageSize: 10 }));
  //   return new Promise(function (resolve, reject) {
  //     xhr.onload = function () {
  //       resolve(xhr.responseText);
  //     };
  //     token.cancel = function () {
  //       // SPECIFY CANCELLATION
  //       xhr.abort(); // abort request
  //       reject(new Error("Cancelled")); // reject the promise
  //     };
  //     xhr.onerror = reject;
  //   });
  // }
  // let token = {};
  // let promise = delayedSaleTicketTask(token);
  // promise
  //   .then((saleArr) => onSaleTicketSuccess(JSON.parse(saleArr)))
  //   .catch((errorObj) => {
  //     cancelDebounce = true;
  //     isPollingInProgress = false;
  //     //   setPollingInProgress(false);
  //     if (errorObj.code === "REST_TICKET_POLLING_UNAUTHORIZED") {
  //       // clearDelayedTasks(delayedSaleTicketTask);
  //       token.cancel();
  //       return;
  //     }
  //     //   Rista.CommonHelper.showToast("Ticket fetch failed. " + Rista.MessageUtil.getMessage(errorObj.code));
  //     resetDelayedTask(15000);
  //   });
  const { isTicketPrinter, isLabelPrinter } = getPollingConfig();


  getUnprintedTicketsFn({
    dataToSend: { pageSize: 10 },
    ticketsToggle: isTicketPrinter,
    labelsToggle: isLabelPrinter,
    callback: onUnprintedSalesSuccess,
    errorCallback: (error) => {
      cancelDebounce = true;
      isPollingInProgress = false;
      if (error?.code === "REST_TICKET_POLLING_UNAUTHORIZED") {
        // clearDelayedTasks(delayedSaleTicketTask);
        // token.cancel();
        return;
      }
      // Rista.CommonHelper.showToast("Ticket fetch failed. " + Rista.MessageUtil.getMessage(error.code));
      resetDelayedTask(15000);
    },
  });
}

// function onSaleTicketError(errorObj) {
//   setPollingInProgress(false);
//   if (errorObj.code === "REST_TICKET_POLLING_UNAUTHORIZED") {
//     clearDelayedTasks(delayedSaleTicketTask);
//     return;
//   }
//   Rista.CommonHelper.showToast("Ticket fetch failed. " + Rista.MessageUtil.getMessage(errorObj.code));
//   resetDelayedTask(15000);

// }

//! STEP3 : TICKETS AND LABEL FETCH SUCCESS
function onUnprintedSalesSuccess(saleArr) {
  console.log("------POLLING-----UNPRINTED=", saleArr);
  // let me = this;
  const ticketSales = saleArr?.ticketSales || [];
  const itemLabelSales = saleArr?.itemLabelSales || [];
  // resetDelayedTask(me.checkSaleTaskQueue, 15000);
  if (!ticketSales.length && !itemLabelSales.length) {
    isPollingInProgress = false;
    resetDelayedTask(10000);
    return;
  }

  printUnprintedSalesSequentially(ticketSales, itemLabelSales);
}

function printUnprintedSalesSequentially(ticketSales = [], itemLabelSales = []) {

  if (itemLabelSales.length) {
    printItemLabels(itemLabelSales);
  }

  if (ticketSales.length) {
    printSaleTickets(ticketSales);
  }
  setTimeout(() => {
    if (!cancelDebounce) {
      taskQ = [];
      // console.log('taskQ',taskQ)
      isPollingInProgress = false;
      pollForTickets();
    }
    //   console.timeEnd('Polling_start_1')
  }, 15000);
}

//! STEP 4: PRINT UNPRINTED SALES
function printSaleTickets(ticketSales = []) {
  let i = 0;
  let count = ticketSales.length;
  function printTickets() {
    let sale = ticketSales[i];

    if (taskQ.includes(sale.mid)) {
      i++;
      if (i < count) setTimeout(printTickets, 100);
      return;
    }

    if (!taskQ.includes(sale.mid)) {
      taskQ.push(sale.mid);
    }
    // updatePollingTaskQ(sale.mid, true);
    printSaleTicketsConfig(sale);
    i++;
    if (i < count) {
      setTimeout(printTickets, 100);
    }
  }
  printTickets();
}


function printItemLabels(itemLabelSales = []) {
  let i = 0;
  let count = itemLabelSales.length;
  console.log("===>Item label sales to print:", itemLabelSales);
  function printLabels() {
    let sale = itemLabelSales[i];

    if (taskQ.includes(sale.mid)) {
      i++;
      if (i < count) setTimeout(printLabels, 100);
      return;
    }

    else {
      taskQ.push(sale.mid);
    }
    printItemLabelConfig(sale);

    i++;
    if (i < count) {
      setTimeout(printLabels, 100);
    }
  }

  printLabels();
}


//!STEP5 : UPDATE PRINTER CONFIG IN UNPRINTED SALES
function printSaleTicketsConfig(sale, retryCount) {
  // debugger;
  let ticketsToPrint = [];
  if (!sale || !sale.tickets?.length) {
    return;
  }
  let pendingTickets = 0;
  sale?.tickets?.forEach(function (saleTicket) {
    if (saleTicket.printStatus === "Pending") {
      pendingTickets++;
      ticketsToPrint.push(saleTicket);
    }
  });

  let salePrintParams;
  if (
    sale.fulfillmentStatus === "Accepted" &&
    sale.tickets?.length === pendingTickets &&
    sale.printLog &&
    sale.printLog?.length === 1 &&
    sale.printLog?.[0]?.auto &&
    store.getState().catalogStore?.posSettings &&
    store.getState().catalogStore?.posSettings?.tickets?.printDeviceId === getLocalStorage(LOCALSTORAGE_KEYS.deviceIdentifier)
  ) {
    let printerRecord = store.getState().printerStore?.defaultPrinter || {};

    if (Object.keys(printerRecord)?.length) {
      salePrintParams = {
        sale: sale,
        printer: printerRecord,
        printCount: sale?.printLog[0]?.printCount,
      };
    }
  }
  if (ticketsToPrint?.length) {
    // Ext.Viewport.fireEvent(
    //   "printtickets",
    //   Rista.CommonHelper.getTickets(sale, ticketsToPrint, true),
    //   null,
    //   salePrintParams
    // );
    let ticketsToPrintArr = getTickets(sale, ticketsToPrint, true);
    printTickets(ticketsToPrintArr, null, salePrintParams);
  }
}

function printItemLabelConfig(sale) {
  const itemLabelSettings =
    store.getState()?.catalogStore?.posSettings?.itemLabelSettings;

  if (!itemLabelSettings) {
    console.warn("Item label settings missing");
    return;
  }

  const printerId = itemLabelSettings?.printerId?.[0];

  const allLabelPrintersList = getAllAddedLabelPrintersList();
  const allLabelPrintersMap = arrayToMap(allLabelPrintersList, "mid") || {};

  if (!allLabelPrintersMap[printerId]) {
    ToastNotifyError(getErrorMessage("UI_ERR_SELECT_PRINTER_FROM_POS"));
    return;
  }

  const printerObj = { sale, itemLabelSettings };

  const printData =
    window.RL?.bill?.getItemLabelPrintContent(structuredClone(printerObj));

  if (isEmpty(printData)) return;

  const labelUnits = getLabels(sale, itemLabelSettings);

  printLabels(labelUnits, printData, allLabelPrintersMap, 1);
}



function getLabels(sale, itemLabelSettings) {
  if (!sale || !sale.saleItems?.length) return [];

  return sale.saleItems.reduce((arr, item) => {
    const qty = item.quantity || 1;

    for (let i = 0; i < qty; i++) {
      arr.push({
        saleId: sale.mid,
        itemId: item.itemId || item.mid,
        labelIndex: i + 1,
        printStatus: "Pending",
        itemLabelSettings,
      });
    }

    return arr;
  }, []);
}




function getTickets(saleData, tickets, auto) {
  let ticketData,
    saleItems = [],
    saleItem,
    itemOptions,
    ticketDataArr = [],
    billHeader,
    createdBy,
    contactInfo;
  let ticketSettings = store.getState().catalogStore?.posSettings?.tickets || {};
  let groups = ticketSettings.groups;
  if (!tickets?.length) {
    return [];
  }

  let printTemplate = ticketSettings?.printTemplate || {};

  tickets?.forEach(function (ticket) {
    ticketData = {};
    saleItems = [];
    createdBy = ticket.createdBy;
    //To be used for processing
    ticketData.saleId = saleData.mid;
    ticketData.printed = ticket.printed;
    ticketData.printStatus = ticket.printStatus;
    ticketData.ticketNumber = ticket.ticketNumber;
    ticketData.sourceInfo = saleData.sourceInfo;
    if (ticket.ticketStatus !== "Cancelled") {
      ticketData.ticketNote1 = ticket.ticketNote1;
      ticketData.ticketNote2 = ticket.ticketNote2;
    }

    //Do not print items for cancelled sale tickets.
    if (!ticket?.saleItems?.length) {
      saleData?.saleItems.forEach(function (item) {
        if (item?.ticketNumber === ticket?.ticketNumber) {
          saleItem = {};
          saleItem.shortName = item?.shortName;
          saleItem.quantity = item?.quantity;
          saleItem.note = item?.note;
          saleItem.variantValues = item?.variantValues;

          if (item?.itemOptionList?.length) {
            itemOptions = [];
            item?.itemOptionList?.forEach(function (itemOption) {
              itemOptions.push({ name: itemOption?.name, quantity: itemOption?.quantity });
            });
            saleItem.itemOptionList = itemOptions;
          }
          saleItems.push(saleItem);
        }
      });
    } else {
      saleItems = ticket?.saleItems;
    }

    ticketData.billTitle = "Service Ticket";
    if (ticket?.isBackOrderTicket) {
      ticketData.billTitle = "Backorder Ticket";
    }
    if (ticket?.groupName) {
      ticketData.billTitle = ticketData?.billTitle + ":" + ticket?.groupName;
    }
    //When reprint is fired, add reprint to the title. When Cancel ticket is printed, print cancel on title.
    if (ticketData.printStatus === "Completed") {
      ticketData.billTitle = ticketData?.billTitle + " (Reprint)";
    } else if (ticket.ticketStatus === "Cancelled") {
      ticketData.billTitle = ticketData?.billTitle + " (Cancelled)";
    } else if (saleData.saleStatus === "Cancelled") {
      ticketData.billTitle = ticketData?.billTitle + " (Cancelled)";
    } else if (auto !== true) {
      ticketData.billTitle = ticketData?.billTitle + "(Manual Print)";
    }
    if (!(createdBy && createdBy?.date)) {
      createdBy = {};
      createdBy.date = moment().tz(store.getState()?.businessStore?.businessData?.timeZone?.zoneId).format();
      ticket.createdBy = createdBy;
    }
    ticketData.itemCount = saleItems?.length;
    ticketData.serviceLabel = saleData?.serviceLabel;
    if (saleData.deliveryInfo) {
      ticketData.deliveryInfo = {
        mode: saleData?.deliveryInfo?.mode,
        deliveryDate: saleData?.deliveryInfo?.deliveryDate,
      };
    }
    if (!ticketData?.serviceLabel || !ticketData.serviceLabel.resourceId) {
      if (saleData?.deliveryInfo) {
        contactInfo = saleData?.deliveryInfo?.contactInfo || {};
        ticketData.deliveryInfo.contactInfo = { name: contactInfo?.name };
      } else if (saleData.customerInfo) {
        contactInfo = saleData?.customerInfo?.contactInfo || {};
        ticketData.customerInfo = { contactInfo: { name: contactInfo?.name } };
      }
    }

    ticketData.updatedBy = ticket?.updatedBy || ticket?.createdBy;
    ticketData.saleBy = saleData?.saleBy;
    ticketData.note = saleData?.note;
    ticketData.showChannelName = saleData?.showChannelName;
    if (!printTemplate.hideChannelInfo) {
      ticketData.showChannelName = true;
    }
    ticketData.channelName = saleData?.channelName;
    ticketData.showNote = true;
    ticketData.groupName = ticket?.groupName;
    ticketData.isAggregatedTicket = ticket?.isAggregatedTicket;
    ticketData.isTransferTicket = ticket?.isTransferTicket;
    ticketData.isBackOrderTicket = ticket?.isBackOrderTicket;
    ticketData.billNumber = ticketData?.ticketNumber;
    ticketData.saleItems = saleItems;
    ticketData.tags = saleData?.tags;
    if (ticket.ticketCancelReason) {
      ticketData.ticketCancelReason = ticket?.ticketCancelReason;
    }
    if (ticketData?.groupName && groups?.length) {
      groups?.forEach(function (group) {
        if (group.name === ticketData?.groupName) {
          if (group?.showBillBarcode) {
            ticketData.billNumberBarcode = saleData?.billNumber || saleData?.offlineNumber;
          }

          if (group?.pinSupport) {
            ticketData.pinSupport = true;
          }

          if (!group?.showItemBarcode) {
            ticketData?.saleItems?.forEach(function (saleItem) {
              delete saleItem?.barCode;
            });
          }

          if (group?.footer) {
            ticketData.billFooter = group?.footer;
          }
        }
      });
    }
    if (saleData?.billHeader) {
      billHeader = {};
      if (!saleData?.billHeader?.brandName) {
        billHeader.businessName = saleData.billHeader?.businessName;
      }
      billHeader.brandName = saleData?.billHeader?.brandName;
    }
    ticketData.billHeader = billHeader;

    if (printTemplate?.hideBusinessInfo) {
      delete ticketData?.billHeader;
    }

    if (printTemplate?.hideChannelInfo) {
      delete ticketData?.showChannelName;
      delete ticketData?.channelName;
    }

    if (printTemplate?.hideServiceLabelInfo) {
      delete ticketData?.serviceLabel;
    }

    if (printTemplate?.hideCustomerInfo) {
      delete ticketData?.customerInfo;
    }

    if (printTemplate?.hideDeliveryInfo) {
      delete ticketData?.deliveryInfo;
    }

    if (printTemplate?.hideSourceInfo) {
      delete ticketData?.sourceInfo;
    }

    if (printTemplate?.hideSaleByAndDate) {
      delete ticketData?.updatedBy;
      delete ticketData?.saleBy;
    }

    ticketDataArr.push(ticketData);
  });
  return ticketDataArr;
}

//! STEP 6: update sale status
function printLabels(labelDataArr, printDataMap, printersMap, retryCount = 1) {
  let labelInfoArr = labelDataArr.reduce((arr, l) => {
    if (l.printStatus === "Pending" || l.printStatus === "Failed") {
      arr.push({
        itemId: l.itemId,
        labelIndex: l.labelIndex,
        printStatus: "Completed",
        printSource: "Poller",
      });
    }
    return arr;
  }, []),
  saleId = labelDataArr[0]?.saleId,
  timeout;

  // update status 
  if (labelInfoArr.length) {
    updateLabelStatus(
      { labelInfos: labelInfoArr },
      saleId,
      {
        successCallback: function () {
          // remove sale from taskQ 
          taskQ = taskQ.filter((sale) => sale !== saleId);

          if (!taskQ.length) {
            isPollingInProgress = false;
            cancelDebounce = true;
          }

          Object.keys(printDataMap).forEach((printerMid) => {
            const printerConfig = printersMap[printerMid];
            if (!printerConfig) return;

            if (isElectron()) {
              window.electronAPI.printer.print(printDataMap[printerMid], printerConfig);
            } else {
              exec(NW_APP_EVENT_KEYS.printer, NW_APP_EVENT_ACTIONS.printer.print, [
                printDataMap[printerMid],
                printerConfig,
              ]);
            }
          });
        },

        appErrorCallback: function () {
          taskQ = taskQ.filter((sale) => sale !== saleId);
          isPollingInProgress = false;
          cancelDebounce = true;
          pollForTickets();
        },

        failureCallback: function () {
          taskQ = taskQ.filter((sale) => sale !== saleId);

          if (typeof retryCount !== "number") retryCount = 2;

          if (retryCount > 0) {
            timeout = 4000 / retryCount;
            retryCount--;
            setTimeout(() => {
              printLabels(labelDataArr, printDataMap, printersMap, retryCount);
            }, timeout);
            return;
          }
        },
      }
    );
  }
}


function printTickets(ticketDataArr, retryCount = 1, salePrintParams) {
  let printerData,
    ticketInfoArr = [],
    ticketNumbers = [],
    timeout,
    reprintTickets = [],
    saleId = ticketDataArr[0]?.saleId;
  ticketDataArr?.forEach(function (ticketData) {
    let printers = getPrintersForTicket(ticketData);
    if (!printers?.length) {
      return;
    }
    if (ticketData?.printStatus === "Pending" || ticketData?.printStatus === "Failed") {
      ticketInfoArr.push({ ticketNumber: ticketData?.ticketNumber, printStatus: "Completed", printSource: "Poller" });
    } else {
      reprintTickets.push({ ticketData: ticketData, printers: printers });
    }
  });

  if (ticketInfoArr?.length) {
    updateTicketStatus({ ticketInfos: ticketInfoArr }, saleId, {
      successCallback: function () {
        // console.log("123InsideUpadteTicketStatus_successCallback");
        taskQ = taskQ.filter((sale) => {
          return saleId != sale;
        });

        if (!taskQ?.length) {
          // console.timeEnd('Polling_start_1')
          isPollingInProgress = false
          cancelDebounce = true
          pollForTickets()
        }
        //   me.updatePollingTaskQ(saleId, false);
        let ticketNumbersObj = arrayToMap(ticketInfoArr, "ticketNumber");
        ticketNumbers = Object.keys(ticketNumbersObj)?.map((key) => {
          // return {[key] : ticketNumbersObj[key]}
          return key;
        });

        //   ticketNumbers =  Ext.pluck(ticketInfoArr, "ticketNumber");
        ticketDataArr?.forEach(function (ticketData) {
          if (ticketNumbers.indexOf(ticketData?.ticketNumber) > -1) {
            let printers = getPrintersForTicket(ticketData);
            printers?.forEach(function (printerData) {
              printSale(ticketData, printerData?.printer, printerData?.copies);
            });
          }
        });

        if (salePrintParams && salePrintParams?.sale && salePrintParams?.printer && salePrintParams?.sale?.saleStatus?.toLowerCase() === CLOSED) {
          printSale(salePrintParams.sale, salePrintParams.printer, salePrintParams.printCount);
        }
      },
      appErrorCallback: function (errorObj) {
        taskQ = taskQ.filter((sale) => {
          return sale != saleId;
        });
        if (!taskQ?.length) {
          isPollingInProgress = false
          cancelDebounce = true
          pollForTickets()
        }
        //   me.updatePollingTaskQ(saleId, false);
        //   Ext.Msg.alert("", Rista.MessageUtil.getMessage(errorObj.code));
      },
      failureCallback: function () {
        taskQ = taskQ.filter((sale) => {
          return sale != saleId;
        });

        //   me.updatePollingTaskQ(saleId, false);
        if (typeof retryCount !== "number") {
          retryCount = 2;
        }
        if (retryCount > 0) {
          timeout = 4000 / retryCount;
          retryCount--;
          setTimeout(function () {
            printTickets(ticketDataArr, retryCount);
          }, timeout);
          return;
        }
        //   Rista.CommonHelper.showToast(Rista.MessageUtil.getMessage("UI_MSG_TICKET_PRINT_FAILED"));
      },
    });
  }

  if (reprintTickets?.length) {
    reprintTickets.forEach(function (reprintData) {
      reprintData.printers.forEach(function (printerData) {
        printSale(reprintData.ticketData, printerData.printer, printerData.copies);
      });
    });
  }
}

function getPrintersForTicket(saleData) {
  let allPrintersList = store.getState().printerStore?.allPrinters || [],
    localPrintersList = store.getState().printerStore?.localPrinters || [],
    blePrinterList = getAddedBlePrintersList();

  let allPrinters = [
    ...allPrintersList,
    ...localPrintersList,
    ...blePrinterList,
  ];

  let printersMap = arrayToMap(allPrinters, "mid") || [];
  let printers = [];
  let printer;
  let resourceGroupId;
  let posSettings = store.getState()?.catalogStore?.posSettings;
  try {
    // let printerStore = store.getState()?.printerStore;
    // let copies;
    // resourceId,
    // localPrinters = ["usb-printer", "bluetooth-printer"];
    if (!Object.keys(posSettings?.tickets)?.length) {
      return;
    }
    let tickets = posSettings?.tickets;
    if (saleData?.serviceLabel && saleData?.serviceLabel?.resourceGroupId) {
      resourceGroupId = saleData?.serviceLabel?.resourceGroupId;
    } else {
      resourceGroupId = "noresourcegroup";
    }
    if (tickets && !tickets?.groups?.length) {
      printer = store.getState().printerStore?.defaultPrinter || {};
      if (Object.keys(printer || {})?.length) {
        printers.push({ printer: printer });
      }
    } else if (saleData?.groupName && tickets?.groups?.length) {
      tickets?.groups?.forEach(function (ticketGroup) {
        if (ticketGroup?.name === saleData?.groupName) {
          if (ticketGroup?.printers?.length) {
            ticketGroup?.printers?.forEach(function (ticketGroupPrinter) {
              if (
                ticketGroupPrinter?.resourceGroupIds?.length &&
                (!resourceGroupId || ticketGroupPrinter?.resourceGroupIds?.indexOf(resourceGroupId) === -1)
              ) {
                return;
              }
              if (
                (ticketGroupPrinter?.itemType === "Regular" && saleData?.isBackOrderTicket) ||
                (ticketGroupPrinter?.itemType === "Back Order" && !saleData?.isBackOrderTicket)
              ) {
                return;
              }
              console.log("===============ticketGroup inside polling", ticketGroup);
              if (ticketGroupPrinter.printerId === PRINTER_TYPES_KEYS.defaultPrinter)
                printer = store.getState().printerStore?.defaultPrinter || {};
              else if (ticketGroupPrinter.printerId === PRINTER_TYPES_KEYS.USB_PRINTER)
                printer = USBPrinter();
              else
                printer = printersMap?.[ticketGroupPrinter?.printerId] || {};

              if (Object.keys(printer)?.length) {
                printers.push({ printer: printer, copies: ticketGroupPrinter?.copies || 1 });
              }
            });
          }
        }
      });
      return printers;
    }
  } catch (error) {
    console.log("err:", error);
    return error;
  }
}

function updateLabelStatus(params, saleId, callbacks) {
  let payload = {
    id: saleId,
    labelInfos: params.labelInfos || [],
  };

  if (isOffline()) {
    callbacks?.successCallback();
    return;
  }

  store.dispatch(
    printLabelSlice({
      ...payload,
      callback: callbacks?.successCallback,
      errorCallback: callbacks?.appErrorCallback,
    })
  );
}


function updateTicketStatus(params, saleId, callbacks, scope, otherParams) {
  // function delayedSaleTicketTask() {
  //   // the token is for cancellation
  //   let url = `${RISTA_API_URL}${RISTA_COMMON_URL}/sale/${saleId}/ticket/printstatus`;
  //   let xhr = new XMLHttpRequest();
  //   xhr.open("POST", url, true);
  //   xhr.setRequestHeader("Content-type", "application/json");
  //   xhr.setRequestHeader("deviceIdentifier", getLocalStorage("deviceIdentifier"));
  //   xhr.setRequestHeader("ATOKEN", getLocalStorage("ATOKEN"));
  //   xhr.send(JSON.stringify(params));
  //   return new Promise(function (resolve, reject) {
  //     xhr.onload = function () {
  //       resolve(xhr.responseText);
  //     };
  //     xhr.onerror = reject;
  //   });
  // }

  // let promise = delayedSaleTicketTask();
  // promise
  //   .then((obj) => {
  //     if (obj?.code) {
  //       callbacks?.failureCallback();
  //     } else {
  //       callbacks?.successCallback();
  //     }
  //   })
  //   .catch((errorObj) => callbacks?.appErrorCallback());

  let payload = {
    id: saleId,
    ticketInfos: params.ticketInfos || [],
  };
  if (isOffline()) {
    updateAllTicketsPrintStatus({
      ...payload,
      cb: (res, err) => {
        if (res?.code) {
          callbacks?.failureCallback();
        } else if (err) {
          callbacks?.appErrorCallback();
        } else {
          callbacks?.successCallback();
        }
      },
    });
  } else {
    store.dispatch(
      printKOTSlice({
        ...payload,
        callback: (response) => {
          if (response?.code) {
            callbacks?.failureCallback();
          } else {
            callbacks?.successCallback();
          }
        },
        errorCallback: (error) => {
          callbacks?.appErrorCallback();
        },
      })
    );
  }
}
